import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from '../../shared/services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class OrderService {

    constructor(protected http: HttpClient, private auth: AuthService) {
    }

    getHeaders() {
        const token = 'Bearer ' + this.auth.getToken();

        return new HttpHeaders({
            Authorization: token,
            'Content-Type': 'application/json'
        });
    }

    getOrder(order_id) {
        return this.http.get(environment.amenaEndpoint + 'order/' + order_id, {headers: this.getHeaders()});
    }

    getDocument(amena_order_id) {
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + this.auth.getToken(),
            'Content-Type': 'application/pdf'
        });

        return this.http.get(environment.amenaEndpoint + 'order/contract/' + amena_order_id + '/download', {headers, responseType: 'blob'});
    }

    getDocumentPrivacy(amena_order_id) {
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + this.auth.getToken(),
            'Content-Type': 'application/pdf'
        });

        return this.http.get(environment.amenaEndpoint + 'order/contract/' + amena_order_id + '/privacy/download', {headers, responseType: 'blob'});
    }
}
